"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * REST API Detection Catalog
 * This schema defines the REST API endpoints for the detection catalog
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectionStatusToJSON = exports.DetectionStatusFromJSONTyped = exports.DetectionStatusFromJSON = exports.DetectionStatus = void 0;
/**
 * The status of the detection
 * @export
 */
exports.DetectionStatus = {
    Active: 'active',
    Retired: 'retired',
    Beta: 'beta',
    Unavailable: 'unavailable',
    Disabled: 'disabled'
};
function DetectionStatusFromJSON(json) {
    return DetectionStatusFromJSONTyped(json, false);
}
exports.DetectionStatusFromJSON = DetectionStatusFromJSON;
function DetectionStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DetectionStatusFromJSONTyped = DetectionStatusFromJSONTyped;
function DetectionStatusToJSON(value) {
    return value;
}
exports.DetectionStatusToJSON = DetectionStatusToJSON;
